const config = {
    firebase: {
        apiKey: "AIzaSyBCsXsO0viR5AyrKK2LxOnvtg59zC5Cq9Q",
        authDomain: "akokomarket-d5e1f.firebaseapp.com",
        databaseURL: "https://akokomarket-d5e1f.firebaseio.com",
        projectId: "akokomarket-d5e1f",
        storageBucket: "akokomarket-d5e1f.appspot.com",
        messagingSenderId: "325824432725",
        appId: "1:325824432725:web:d8da24448c8a0897b6a2dc",
        measurementId: "G-BJJ6F7W2JV"
    }
}

export default config;